import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=3ed6db99&scoped=true"
var script = {}
import style0 from "./Navbar.vue?vue&type=style&index=0&id=3ed6db99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed6db99",
  null
  
)

export default component.exports